module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.main.loaded.search) ? _c('div', {
    staticClass: "grid align-end"
  }, [(!_vm.main.loaded.text) ? _c('div', {
    attrs: {
      "id": "exit"
    },
    on: {
      "click": _vm.exit
    }
  }, [_c('span', [_vm._v("exit search")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.main.search), function(item, index) {
    return _c('item', {
      attrs: {
        "index": index,
        "item": item
      }
    })
  })], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4d30419c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/search.vue
// module id = 473
// module chunks = 2